import { render, staticRenderFns } from "./BandejaCoordinadorEspecialidadReplicaRechazada.vue?vue&type=template&id=73d1ea3e"
import script from "./BandejaCoordinadorEspecialidadReplicaRechazada.vue?vue&type=script&lang=js"
export * from "./BandejaCoordinadorEspecialidadReplicaRechazada.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports